import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateSessionTitle } from '../../../services/api';
import { AGENT_SESSIONS } from '../../../constants/queryKeys';

const useRenameSession = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ sessionId, title }: { sessionId: string; title: string }) =>
      updateSessionTitle(sessionId, title),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [AGENT_SESSIONS] });
    },
  });
};

export default useRenameSession;
